// extracted by css-extract-rspack-plugin
export default {"sidebar":"G6g7e"};